import {eventUrl} from './base';
import {myAxios} from "../util/myAxios";
import type {Event} from "../entities/Event"

export function getEvent(): Promise<Event> {
  return myAxios()
    .then(axious => axious.get(eventUrl()))
    .then(response => response.data)
}
